import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { map, switchMap, of } from 'rxjs';

/**
 * Auth guard that validates BFF session.
 * If user is not authenticated locally, attempts to validate BFF session.
 * Redirects to login if session is invalid.
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    switchMap(isAuthenticated => {
      if (!isAuthenticated) {
        // No local user state, try to validate BFF session
        return authService.validateSession().pipe(
          map(user => {
            if (user) {
              return true; // Session valid, allow navigation
            }
            router.navigate(['/login']);
            return false;
          })
        );
      }
      return of(true); // User already authenticated locally
    })
  );
};
